import Raven from 'raven-js';
export const reportError = ({
  error,
  tags = {},
  ignoreMeta = {
    errorStatus: []
  },
  extraData = {}
}) => {
  if (error && typeof error === 'object' && 'status' in error && ignoreMeta.errorStatus.some(status => status === error.status)) {
    return null;
  } // See: https://hubspot.slack.com/archives/C017FT4P2Q0/p1627310334063600
  // @ts-expect-error custom window types aren't available in all builds


  const newRelicWindow = window.newrelic;

  if (newRelicWindow && newRelicWindow.noticeError) {
    newRelicWindow.noticeError(error, Object.assign({}, tags, {}, extraData));
  }

  const errorToReport = error instanceof Error ? error : new Error(error.message);
  Raven.captureException(errorToReport, {
    tags,
    extra: Object.assign({}, extraData, {
      error
    })
  });
  const lastEventId = Raven.lastEventId();
  console.error(`(Event Id: ${lastEventId})\nError reported with '${error.message}'`);
  return lastEventId;
};